    import { Chip, DrawerBodyWrapper, ItemCard } from '@base'
    import { strings } from '@constants'
    import { Spacings } from '@styles'
    import { displayAmount, showDateFormat } from '@utils'
    import React from 'react'
    import styled from 'styled-components'

    const DrawerBody = styled(DrawerBodyWrapper)`
        display: flex;
        flex-direction: column;
        padding: ${Spacings.SPACING_4B};
        ${Spacings.SPACING_6B};
        gap: ${Spacings.SPACING_2B};
    `
    const HeaderWapper = styled.div`
        display: flex;
        align-items: center;
        gap: ${Spacings.SPACING_2B};
        justify-content: space-between;
    `

    const LedgerDetails = ({ rowData }) => {

        const ItemData = [
            {
                label: strings(['original', 'document', 'number']),
                value: rowData?.original_document_number ?? '-',
            },
            {
                label: strings('invoice', 'date'),
                value: rowData?.transaction_date ? showDateFormat(new Date(rowData?.transaction_date)) : '-',
            },
            {
                label: strings('amount'),
                value: displayAmount(rowData?.transaction_amount) ?? '-',
            },
            {
                label: strings('balance'),
                value: displayAmount(rowData?.balance) ?? '-',
            },
            {
                label: strings('transaction', 'type'),
                value: rowData?.transaction_type ?? '-',
            },

            {
                label: strings('due', 'date'),
                value: rowData?.due_date ? showDateFormat(new Date(rowData?.due_date)) : '-',
            },

            {
                label: strings('zoho', 'id'),
                value: rowData?.zoho_id ?? '-',
            },
        ]

        const ItemData2 = [
            {
                label: strings('order', 'id'),
                value: rowData?.order_id ?? '-',
            },
            {
                label: strings('order', 'date'),
                value: rowData?.order_date ? showDateFormat(new Date(rowData?.order_date)) : '-',
            },
            {
                label: strings('platform'),
                value: rowData?.platform ?? '-',
            },
            {
                label: strings('region'),
                value: rowData?.region ? rowData?.region : '-',
            },
            {
                label: strings('commodity'),
                value: rowData?.commodity?.commodity_name ?? '-',
            },
            {
                label: strings('transaction', 'source'),
                value: rowData?.transaction_source ?? '-',
            },
            {
                label: strings('sales', 'manager'),
                value: (rowData?.sales_managers?.[0]?.full_name || rowData?.sales_managers?.[0]?.organisation_name) ?? '-',
            },
            {
                label: strings('supply', 'manager'),
                value: (rowData?.supply_managers?.[0]?.full_name || rowData?.supply_managers?.[0]?.organisation_name) ?? '-',
            },
        ]

        const CardOne = () => <ItemCard small clickable={false} data={ItemData} rowData={true} />
        const CardTwo = () => <ItemCard small clickable={false} data={ItemData2} rowData={true} />

        return (
            <DrawerBody>
                <HeaderWapper>
                    <div>{`${rowData?.user_details?.organisation_name} (${rowData?.user_details?.organisation_id})`}</div>
                    <Chip label={rowData?.zoho_status ?? '-'} />
                </HeaderWapper>
                <div>
                    {CardOne()}
                    {CardTwo()}
                    Remarks: {rowData?.transaction_remarks}
                </div>
            </DrawerBody>
        )
    }

    export default LedgerDetails
